"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyDefinition = propertyDefinition;
const property_1 = require("@genesys/property");
function propertyDefinition() {
    return [
        {
            sort_no: 1,
            name: "calculationmethod",
            group: "",
            quantity: "Discrete",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.Empty,
            value: [
                {
                    sort_no: 0,
                    value: {
                        type: "integer",
                        value: 0
                    },
                    property_filter: property_1.PropertyFilter.Empty
                },
                {
                    sort_no: 1,
                    value: {
                        type: "integer",
                        value: 1
                    },
                    property_filter: property_1.PropertyFilter.Empty
                }
            ]
        },
        {
            sort_no: 2,
            name: "calculationmethodtargettemperature",
            group: "",
            quantity: "Temperature",
            validation_filter: property_1.PropertyFilter.Empty,
            visibility_filter: property_1.PropertyFilter.fromString("calculationmethod=1"),
            value: []
        }
    ];
}
//# sourceMappingURL=calculationmethod-definition.js.map